/* eslint-disable no-param-reassign */
import styled, { css } from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';
import { gap } from '../../../../juristec-ui/styles/theme';

const getContrastYIQ = (hexcolor) => {
  hexcolor = hexcolor.replace('#', '');
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? 'black' : 'white';
};

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const IconWrapper = styled.div`
  display: flex;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
  margin: auto;
  & svg {
    margin: auto;
    fill: ${({ theme }) => theme.primary};
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 35vw;
  height: 35vh;
  padding: 0 .5rem;
  user-select: none;
  @media ${devices.phoneS} {
    flex-direction: column-reverse;
  }
`;

export const CreateReportContainer = styled(Column)`
  box-sizing: border-box;
  margin: 0;
  width: 40vw;
  height: 50vh;
  overflow-y: auto;
  @media ${devices.phoneS} {
    width: 100%;
    margin: 15px 0 0 0;
  }
  & > span {
    align-self: end;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.container};
  width: 100%;
  height: 100%;
  padding: 5px 5px 0 5px;
  box-sizing: border-box;
`;

export const ImagePreview = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  background-color: #C9C9C9;
  aspect-ratio: 1;
  width: 100%;
`;

export const ImageOptions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  width: 100%;
  & > * + * {
    margin-left: 5px;
  }
  & button, button:hover {
    box-shadow: none;
  }
  & .option-disabled {
    opacity: 0.3;
    pointer-events: none;
    & * {
      pointer-events: none;
    }
  }
`;

export const ImageCheckbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: auto;
  & * {
    padding: 0;
  }
  & .box {
    margin-right: 5px;
  }
`;

export const ImageSquare = styled.div`
  background-color: ${({ theme }) => theme.white};
  background-image: ${({ src }) => `url("${src}")`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 0 0 8px 8px;
  width: 100%;

  ${({ bgColor }) => css`
    background-color: ${bgColor};
  `};
`;

export const FormColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 220px;
  grid-gap: 5px;
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  & .dash_color_icon {
    margin-left: 1rem;
  }
`;

export const TitleBasicStyles = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${gap('5px', 'row')};
`;

export const InputWrapper = styled.div`
  margin: 5px 0;
  width: 100%;
  & span {
    position: absolute;
  }
  ${({ disabled }) => disabled && css`
    opacity: 0.3;
    pointer-events: none;
    & * {
      pointer-events: none;
    }
  `}
`;

export const ImageTip = styled.span`
  color: ${({ theme }) => theme.grey};
  font-size: 12px;
  margin-bottom: 0.3rem;
`;

export const ColorPickerContainer = styled.div`
  display: flex;
  flex-direction: row;
  & .under {
  }
  & .over {
    z-index: 1;
  }
`;

export const ColorPickerCircle = styled.div`
  border-radius: 8px;
  width: 35px;
  height: 35px;
  cursor: pointer;

  background-color: ${({ $color }) => $color};
  box-shadow: 0px 1px 2px gray;
  &:hover {
    box-shadow: 0px 1px 5px gray;
  }
`;

export const CheckboxInputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const TabGroup = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  & button {
    margin-bottom: 10px;
    margin-right: 5px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const TabButton = styled.button`
  background-color: ${({ theme }) => theme.container};
  width: 100%;
  height: 45px;
  font-weight: bold;
  border: none;
  box-sizing: border-box;
  color: ${({ theme }) => theme.primary};
  display: flex;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  padding: 5px;
  & svg {
    fill: ${({ theme }) => theme.primary};
    height: 24px;
    width: 24px;
    margin-right: 5px;
  }
  & span {
    margin: auto;
  }
  & .icon-detail {
    transform: rotate(270deg);
    height: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    & svg {
      fill: ${({ theme }) => theme.container};
      margin: 0;
    }
  }
  ${({ theme, active, disabled }) => (active ? css`
    background-color: ${theme.secondary};
    color: ${theme.white};
    & svg {
      fill: ${theme.white};
    }
    & .icon-detail svg {
      fill: ${theme.white};
    }
  ` : css`
    &:hover {
      background-color: ${disabled ? theme.container : theme.selectHover};
      & .icon-detail svg {
        fill: ${theme.selectHover};
      }
    }
  `)}
`;

export const StyledContentTab = styled.div`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 335px);
  @media ${devices.tablet} {
    max-height: calc(100vh - 360px);
  }
  padding: 5px 3px;
  overflow-y: auto;
  overflow-x: hidden;

  & .gap-fix-first {
    display: flex;
    padding: 10px 0px;
    flex-direction: column;
    ${gap('15px', 'column')}
  }

  & .gap-fix-second {
    display: flex;
    flex-direction: row;
    ${gap('5px', 'row')}
  }
`;

export const ModifiersContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  ${gap('10px', 'column')}
`;

export const LabelSmall = styled.span`
  font-weight: bold;
  color: ${({ theme }) => theme.primary};
  margin: 0;
  font-size: 14px;
`;

export const SegregateSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: ${({ theme }) => theme.container};
  border-left: 4px solid ${({ theme }) => theme.primary};
  border-radius: 4px;
  gap: 12px;
  margin-top: 10px;
`;

export const SegregateTitle = styled.h4`
  margin: 0;
  color: ${({ theme }) => theme.primary};
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SegregateDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text};
  font-size: 13px;
  line-height: 1.5;
  
  strong {
    color: ${({ theme }) => theme.primary};
    font-weight: 600;
  }
`;

export const SegregateSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
